import { FeedbackWorkTimeEntry } from "./types/queries";
import { format } from "date-fns";
import {
  hoursMinutesFormat,
  leadingZerosDateFormat,
} from "../../common/helpers/formatDateTime";

export const getShift = (
  translations: Record<string, string>,
  workTimeEntry?: FeedbackWorkTimeEntry,
) => {
  if (!workTimeEntry) return null;
  const translatedWorkTitle =
    translations[workTimeEntry.workTitleId] || workTimeEntry.workTitleId;
  const startDate = format(
    new Date(workTimeEntry.start),
    leadingZerosDateFormat,
  );
  const startTime = format(new Date(workTimeEntry.start), hoursMinutesFormat);
  const endTime = format(new Date(workTimeEntry.end), hoursMinutesFormat);
  return `${translatedWorkTitle}, ${startDate}, ${startTime}-${endTime}`;
};
